import store from '../../store'
import axios from 'axios'
import qs from 'qs'
async function loginRouter(to, from, next) {
  // 確認是否登入(有 token)
  // 取得 userToken // 取得會員種類
  // let userToken = (store.state.user.userToken = to.query.UserToken)
  let userToken = to.query.UserToken === undefined ? '' : to.query.UserToken
  store.state.user.userToken = userToken
  // let clientUserType = (store.state.user.clientUserType = to.query.clientUserType)
  let clientUserType =
    to.query.clientUserType === undefined ? '' : to.query.clientUserType
  store.state.user.clientUserType = clientUserType

  // 根據有沒有 userToken、是否已登入，判斷是否需要登入
  let haveUserToken = userToken || userToken.length !== 0
  let haveClientUserType = clientUserType && clientUserType.length !== 0
  // 如果不需要登入的話就向伺服器要 user data
  // 如果 有 userToken
  // 跟後端進行登入驗證(使後端嘗試呼叫 api 取得使用者資訊)
  if (haveUserToken && haveClientUserType) {
    let url = store.state.api + '/Admin/LoginByToken'
    // let url = '/admin/api/Admin/LoginByToken'
    let data = { userToken: userToken, clientUserType: clientUserType }
    let res = await axios.post(url, qs.stringify(data))
    switch (res.data.resultCode) {
      case '10':
        store.state.user.isLogin = true
        next({ name: 'Admin' })
        break
      case '01':
        throw new Error(
          '嘗試於伺服器驗證 userToken 時發生錯誤，錯誤細節：' + res.data.error
        )
      default:
        throw new Error('嘗試於伺服器驗證 userToken 時，獲得未知的回傳代碼')
    }
  } else {
    // 如果沒有 userToken，確認登入狀態
    // 先用 cookie 確認登入狀態
    let url = store.state.api + '/Admin/CheckLogin'
    // let url =  '/admin/api/Admin/CheckLogin'
    let res = await axios.post(url)
    switch (res.data.resultCode) {
      case '10':
        // 如果已登入，打開 app 首頁
        store.state.user.isLogin = true
        next({ name: 'Admin' })
        break
      case '01':
        // 如果未登入，導入 Login 頁面
        next({ name: 'Login' })
        break
      default:
        throw new Error('嘗試於伺服器驗證登入狀態時，獲得未知的回傳代碼')
    }
  }
}

export default { loginRouter }
